import { Text } from "@clipboard-health/ui-components";
import { Box } from "@mui/material";

export interface FavoritePlacementSuccessMessageProps {
  onClick?: () => void;
}

export function FavoritePlacementSuccessMessage(props: FavoritePlacementSuccessMessageProps) {
  const { onClick } = props;
  return (
    // oxlint-disable-next-line jsx-a11y/prefer-tag-over-role -- Existing pattern, would require refactoring
    <Box role="button" tabIndex={0} onClick={onClick}>
      <Text sx={{ color: "white" }}>
        Job Saved! Visit the{" "}
        <Text sx={{ display: "inline", color: "white", textDecoration: "underline" }}>
          My Jobs Tab
        </Text>{" "}
        to view your saved jobs.
      </Text>
    </Box>
  );
}
